<script>
export default {
  name: 'ChatBadge',
  props: {
    variant: {
      type: String,
      default: 'date',
      validator: (v) => ['date', 'note', 'system'].includes(v),
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeClass() {
      return 'chat-badge--' + this.variant
    },
  },
}
</script>

<template>
  <div class="chat-badge d-inline-flex align-center rounded-pill px-3 py-1" :class="badgeClass">
    <icon-svg
      v-if="icon"
      :name="icon"
      size="12"
      class="mr-1"
      :color="variant === 'note' ? '#F57F17' : variant === 'system' ? '#616161' : '#54656F'"
    />
    <span class="az-text-small font-medium">{{ text }}</span>
  </div>
</template>

<style lang="sass" scoped>
.chat-badge
  user-select: none
  border-radius: 999px !important
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08)

.chat-badge--date
  background-color: #E1F3FB
  color: #54656F

.chat-badge--note
  background: transparent
  box-shadow: none
  padding-left: 0 !important
  padding-right: 0 !important
  color: #F57F17

.chat-badge--system
  background-color: #E8EAF0
  color: #616161
  font-style: italic
</style>
